export default __webpack_public_path__ + "static/media/lantern.45214b39.svg";